import {Directive} from "@angular/core";

@Directive({
  selector: "ng-template[rfContextType]",
  // Inputs defined here to move await from @Input but not use signals since we don't store anything anyway.
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [{name: "rfContextType", required: true}],
})
export class TypedTemplateContext<TParametersType> {
  public set rfContextType(_: TParametersType) {
    // No need to store the type - it's just for type checking.
  }

  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  public static ngTemplateContextGuard<TParametersType>(_: TypedTemplateContext<TParametersType>,
                                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                                        ctx: unknown): ctx is TParametersType {
    return true;
  }
}
